import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/correct.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-625a68ad")

_pushScopeId("data-v-625a68ad")
const _hoisted_1 = { class: "complete" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "content" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: "无法显示图片"
  }),
  /*#__PURE__*/_createVNode("div", { class: "big" }, "支付成功")
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 点击前往主页选取座位 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_router_link, { to: "main" }, {
      default: _withId(() => [
        _hoisted_3
      ]),
      _: 1
    })
  ]))
})